class CompoundCollectionLayout {
  constructor() {
    this.init();
  }

  init() {
    this.setupIntersectionObserver();
    this.setupAnimations();
    this.setupNavigation();
  }

  setupNavigation() {
    const navLinks = document.querySelectorAll('.c-collection-layout__nav-link');
    navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const target = link.dataset.scrollTo;
        this.scrollToSection(target);
      });
    });
    
    // Product card click handler
    const productCards = document.querySelectorAll('[data-product-url]');
    productCards.forEach(card => {
      card.addEventListener('click', () => {
        const url = card.dataset.productUrl;
        if (url) {
          window.location.href = url;
        }
      });
    });
  }

  scrollToSection(target) {
    let section;
    if (target === 'products') {
      section = document.querySelector('.c-collection-layout__section');
    } else if (target === 'bundles') {
      section = document.querySelector('.c-collection-layout__card--bundle-description');
    }
    
    if (section) {
      const headerOffset = 100;
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  setupIntersectionObserver() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animateElement(entry.target);
        }
      });
    }, observerOptions);

    // Observe all animated elements
    const animatedElements = document.querySelectorAll('[data-animation]');
    animatedElements.forEach(element => {
      this.intersectionObserver.observe(element);
    });
  }

  setupAnimations() {
    // Handle hero image scaling
    const heroElements = document.querySelectorAll('[data-animation="img-scales"]');
    heroElements.forEach(element => {
      if (element.classList.contains('c-collection-layout__hero')) {
        const img = element.querySelector('img');
        if (img) {
          img.style.transform = 'scale(1.1)';
          img.style.transition = 'transform 1.2s cubic-bezier(0.36, 0.59, 0.22, 1)';
        }
      }
    });
  }

  animateElement(element) {
    const animationType = element.dataset.animation;
    
    switch (animationType) {
      case 'fade-up':
        this.animateFadeUp(element);
        break;
      case 'line-reveal':
        this.animateLineReveal(element);
        break;
      case 'img-scales':
        this.animateImageScale(element);
        break;
    }
  }

  animateFadeUp(element) {
    element.classList.add('is-animated');
    this.intersectionObserver.unobserve(element);
  }

  animateLineReveal(element) {
    element.style.opacity = '0';
    element.style.transform = 'translateY(20px)';
    element.style.transition = 'opacity 600ms ease, transform 600ms ease';
    
    setTimeout(() => {
      element.style.opacity = '1';
      element.style.transform = 'translateY(0)';
    }, 100);
    
    this.intersectionObserver.unobserve(element);
  }

  animateImageScale(element) {
    const img = element.querySelector('img');
    if (img) {
      img.style.transform = 'scale(1)';
    }
    this.intersectionObserver.unobserve(element);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CompoundCollectionLayout();
});

// Re-initialize if section is reloaded in theme editor
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('shopify-section--compound-collection-layout')) {
    new CompoundCollectionLayout();
  }
});
